import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

const MuiStepConnector = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    line: ({ theme }: { theme: Theme }) => ({ borderColor: theme.palette.divider }),
  },
};

// ----------------------------------------------------------------------

export const stepper = { MuiStepConnector };
